import React from "react";
import Breadcrumb from "../../utils/Breadcrumb";
import { GetAccess } from "../../utils/RolesandAccess";
import { AddIcon, SearchIcon } from "../../assets/icons";
import ToggleViews from "../../utils/ToggleViews";
import Pagination from "../../utils/Pagination";

function ViewFileIndex({
  standardName = "",
  module = "Standard",
  label = "",
  menu = "",
  children,
  total,
  pageIndex,
  setPageIndex = () => {},
  dataCount,
  setDataCount = () => {},
  information = "",
  view = "",
  listView = "",
  cardView = "",
  Access = "",
  setOpenForm = () => {},
  hasSearch = false,
  SearchFuction = () => {},
  SearchQuery = () => {},
}) {

  return (
    <div className="w-full h-full mx-auto">
      <div className="w-[93%] flex justify-start items-center gap-x-6 pb-1 px-3 mx-auto">
        <Breadcrumb
          items={[
            {
              name: module,
            },
            {
              name: standardName,
            },
            {
              name: menu,
            },
            {
              name: label,
            },
          ]}
        />
      </div>
      <div className="w-[96%] mx-auto h-[calc(100vh-105px)] py-2 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)] rounded-2xl overflow-y-auto">
        <div className=" h-9 flex justify-between items-center w-full px-4">
          <p className="text-xs 2xl:text-sm text-text">
            {label}{" "}
            {information != "" && (
              <span className=" w-[94.3%] mx-auto text-[13px] text-slate-500">
                {" "}
                : {information}
              </span>
            )}
          </p>
          <div className=" flex gap-3 justify-center items-center">
          {hasSearch == true && (
              <form className="flex items-center mx-0" onSubmit={SearchFuction}>
                <div
                  className="w-80 h-[34px] relative rounded-md p-1 flex justify-between items-center"
                  style={{ border: "1px solid #EAEBED" }}
                >
                  <input
                    type="text"
                    onChange={(e) => SearchQuery(e)}
                    placeholder="Search Here"
                    className=" w-[90%] text-[13px] px-2 outline-none border-none"
                  />
                  <button
                    className="p-[5.5px] outline-none border-none  cursor-pointer bg-violet-50  rounded-md flex items-center"
                    type="submit"
                  >
                    <SearchIcon />
                  </button>
                </div>
              </form>
            )}
            <ToggleViews view={view} listView={listView} cardView={cardView} />
            <div className=" w-8">
              {GetAccess(Access) && (
                <span onClick={() => setOpenForm(true)}>
                  <AddIcon />
                </span>
              )}
            </div>
          </div>
        </div>
        <div className=" h-[calc(100vh-194px)]  w-full">{children}</div>
        <div className=" h-8 flex justify-between items-center w-full px-4">
          <Pagination
            total={total}
            pageIndex={pageIndex}
            setPageIndex={setPageIndex}
            dataCount={dataCount}
            setDataCount={setDataCount}
          />
        </div>
      </div>
    </div>
  );
}

export default ViewFileIndex;
